import { useComponentVariable } from "../../component/composables/useComponentVariable";
import { useBuiltComponentVariable } from "../../component-built/composables";
export const useSourceComponentVariable = (componentId, variableName) => {
    const { builtComponentVariable } = useBuiltComponentVariable(componentId, variableName);
    const { componentVariable: sourceComponentVariable } = useComponentVariable(() => {
        var _a, _b, _c;
        // TODO - Fix in https://extole.atlassian.net/browse/ENG-23527, not all settings have source_component_id anymore
        if (((_a = builtComponentVariable.value) === null || _a === void 0 ? void 0 : _a.type) === "MULTI_SOCKET" ||
            ((_b = builtComponentVariable.value) === null || _b === void 0 ? void 0 : _b.source) === "PARAMETER") {
            return builtComponentVariable.value.context.componentId;
        }
        return (_c = builtComponentVariable.value) === null || _c === void 0 ? void 0 : _c.source_component_id;
    }, variableName);
    return {
        sourceComponentVariable,
    };
};
